import React, { useState } from 'react';
import { TextField, Button, FormControl, InputLabel } from '@mui/material';
import { Modal } from "antd";
import { useFormik } from "formik";
import * as yup from "yup";
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { addAndUpdateNewFarmCoords } from "hooks/useFarmData";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { useStore } from "../../_Store";
const CoordinateForm = ({ visible, row, onSuccess, onCancel }) => {
  const {
    setUtils,
  } = useStore();
  const [coordinates, setCoordinates] = useState([]);
  const { mutate: addFarmCoords } = addAndUpdateNewFarmCoords();
  const initialValues = {
    latitude: "",
    longitude: "",
  };

  React.useEffect(() => {
    if (row && row.id && row.coordonnates && row.coordonnates.length > 0) {
      let coordonnates = row.coordonnates;
      let tab=[];
      for(const coord of coordonnates){
        tab.push({
          latitude: coord.latitude,
          longitude: coord.longitude,
          farmId:row.id
        });
        setCoordinates(tab);
      }
    }else{
      setCoordinates([])
    } 
  }, [row, visible]);

  const handleCounterIncrement = () => {
    setCoordinates([
      ...coordinates,
      {
        latitude: '',
        longitude: ''
      }
    ]);
  };
  const close = () => {
    formik.resetForm();
    onCancel();
  };
  const handleLatitudeChange = (event, index) => {
    const newCoordinates = [...coordinates];
    newCoordinates[index].latitude = event.target.value;
    newCoordinates[index].farmId = row.id;
    setCoordinates(newCoordinates);
  };

  const handleLongitudeChange = (event, index) => {
    const newCoordinates = [...coordinates];
    newCoordinates[index].longitude = event.target.value;
    setCoordinates(newCoordinates);
  };

  const formik = useFormik({
    initialValues,
    //validationSchema,
    onSubmit: (v) => {
      setUtils("loading", { spinning: true, primary: "" });
      let data={coordonnate : coordinates,farmId:row.id};
        addFarmCoords(data, {
          onSuccess: async (response) => {
            if (response.data.success) {
               close();
              setTimeout(function(){
                location.reload();
              },1000)
              setUtils("loading", { spinning: false, primary: "" });
            } else {
              setUtils("loading", { spinning: false, primary: "" });
            }
          },
        });
    },
  });
  const handleDeleteCoordinate = (index) => {
    const newCoordinates = [...coordinates];
    newCoordinates.splice(index, 1);
    setCoordinates(newCoordinates);
  };

  const handleSetCoordinate = (index) => {
    setUtils("loading", { spinning: true, primary: "" });
    const newCoordinates = [...coordinates];
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          newCoordinates[index] = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            farmId:row.id
          };
          setCoordinates(newCoordinates);
          setUtils("loading", { spinning: false, primary: "" });
        },
        (error) => {
          setUtils("loading", { spinning: false, primary: "" });
          console.error(error);
        }
      );
    } else {
      setUtils("loading", { spinning: false, primary: "" });
      console.error('Geolocation is not supported by this browser.');
    }
  };
  return (
    <React.Fragment>
    <Modal 
    open={visible} 
    width={650}
    centered
    header={null}
    footer={null}
    onCancel={close}
    >
            <form onSubmit={formik.handleSubmit}>
              <h3 style={{ fontSize:"14pt",color:'darkgreen' }} className="mb-2">{`Gestion des coordonnées géograp de l'exploitation ${row.farmName}`}</h3>
            <p className="mb-2"> <strong style={{ color:"darkred",textDecoration:"underline" }}>Note</strong>  : Ajouter des points de coordonnées pour délimiter la zone que couvre votre Champs <strong>{row.farmName}.</strong> </p>
                     
              {coordinates.map((coordinate, index) => (
                <div key={index} className="mt-4">
                      <InputLabel className="mb-2">Coordonnée {parseInt(index)+1}</InputLabel>
                      <TextField
                        id={`coordinates[${index}].latitude`}
                        name={`coordinates[${index}].latitude`}
                        label="Latitude"
                        type="number"
                        value={coordinate.latitude}
                        onChange={(event) => handleLatitudeChange(event, index)}
                        error={formik.touched.coordinates && Boolean(formik.errors.coordinates[index]?.latitude)}
                        helperText={formik.touched.coordinates && formik.errors.coordinates[index]?.latitude}
                      />
                      <TextField
                        id={`coordinates[${index}].longitude`}
                        name={`coordinates[${index}].longitude`}
                        label="Longitude"
                        type="number"
                        style={{ marginLeft:"10px" }}
                        value={coordinate.longitude}
                        onChange={(event) => handleLongitudeChange(event, index)}
                        error={formik.touched.coordinates && Boolean(formik.errors.coordinates[index]?.longitude)}
                        helperText={formik.touched.coordinates && formik.errors.coordinates[index]?.longitude}
                      />
                       <Button variant="outlined" color="success" size="small" style={{ height: "60px",marginLeft:"10px" }} onClick={() => handleSetCoordinate(index)}>
                        <GpsFixedIcon/>
                      </Button>
                      <Button variant="outlined" color="error" size="small" style={{ height: "60px",marginLeft:"10px" }} onClick={() => handleDeleteCoordinate(index)}>
                        <ClearIcon/>
                      </Button>
                     
                </div>
              ))}
                <div className={"mt-4"}>
                  <Button variant="outlined" color="warning" size='small'  onClick={handleCounterIncrement}>
                   <AddIcon/>  Ajouter des coordonnées
                    </Button>
                </div>

                {coordinates && coordinates.length > 0 ?
                  <div className={"mt-4 mb-4 pb-8"}>
                    <Button style={{ float:"right" }} variant="contained" color="primary"  type="submit"> Enregistrer </Button>
                  </div>
                : ""}
             </form>     
    </Modal>
    </React.Fragment>
  );
};

export default CoordinateForm;
